//@ts-nocheck

import isHotkey from 'is-hotkey'
import { Registry } from '@react-registry'
import { Editor, Range, Transforms, Node, Path } from 'slate'

import { outdentMultipleListItems, indentMultipleListItems, outdentMultipleListItemsForUpdatedListStructure, indentMultipleListItemsForUpdatedListStructure } from '../elements/Element/list/ListItem/utils'
import { LIST_TYPES } from '../elements/Element/list/utils'

import { insertRowAtEnd } from '../elements/Element/table/utils/insertRowAtEnd'
import { scrollToCell } from '../elements/Element/table/utils/scrollToCell'

export const handleSoftBreak = ({ editor, event }) => {
  if (isHotkey('tab', event)) {
    if (event.defaultPrevented) {
      return
    }
    event.preventDefault()
    const { selection, rteVersion } = editor
    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n) => n.type === 'li',
        mode: 'lowest'
      })
      const [cell] = Editor.nodes(editor, {
        match: (n) => n.type === 'td' || n.type === 'th',
        mode: 'lowest',
      })

      const [hyperlink] = Editor.nodes(editor, {
        match: (n) => n.type === 'a'
      })

      if (li && ((Range.isCollapsed(selection) && selection.anchor.offset === 0) || Range.isExpanded(selection))) {
        if (rteVersion >= 1) {
          indentMultipleListItemsForUpdatedListStructure(editor)
        } else {
          indentMultipleListItems(editor)
        }
      }
      else if (cell) {

        const [table] = Editor.nodes(editor, {
          match: (n) => n.type === 'table',
          mode: 'lowest',
        })
        const [row] = Editor.nodes(editor, {
          match: (n) => n.type === 'tr',
          mode: 'lowest',
        })
        const [rowParent] = Editor.nodes(editor, {
          match: (n) => n.type === 'tbody' || n.type === 'thead',
          mode: 'lowest'
        })
        const nextCell = Editor.next(editor, {
          match: (n) => ['td', 'th'].includes(n.type) && !editor.isVoid(n),
          mode: 'lowest',
          at: cell[1],
        })
        if (table && rowParent && row) {
          if (nextCell) {
            Transforms.select(editor, nextCell[1])
            return
          }
          insertRowAtEnd(editor, table[1])
          handleSoftBreak({ editor, event })
          return scrollToCell({ editor, scrollToPoint: 'center' });

        }
      }
      else if (hyperlink) {
        let path = hyperlink[1]
        const hasPathPreviousHyperlink = Path.hasPrevious(path)
        if (hasPathPreviousHyperlink) {
          const previousNode = Editor.node(editor, Path.previous(path))
          const isLineBreakNode = previousNode?.[0]?.text === '\n'
          if (isLineBreakNode) {
            Transforms.insertNodes(editor, { text: '\t' }, { at: Path.next(previousNode[1]) })
          }
        }
      }
      else {
        editor.insertText('\t')
      }
    }
  }

  if (isHotkey('shift+enter', event)) {
    event.preventDefault()

    const [list] = Editor.nodes(editor, {
      at: editor.selection,
      match: (n) => n?.['type'] === 'ol' || n?.['type'] === 'ul'
    })

    if (editor.csBreakLineOnEnter && list) {
      editor.insertBreakFromSoftBreak = true
      editor.insertBreak()
      editor.insertBreakFromSoftBreak = false
      return;
    }

    if (editor.csBreakLineOnEnter) {
      Transforms.insertNodes(editor, { type: 'p', children: [{ text: '' }] }, { at: editor.selection, select: true })
      Editor.deleteForward(editor)
      return;
    }

    Editor.withoutNormalizing(editor, () => {
      try {
        const nextNodePath = Path.next(editor.selection?.anchor?.path)
        const nextNode = Editor.hasPath(editor, nextNodePath) ? Editor.node(editor, nextNodePath)?.[0] : null
        editor.insertNode({
          text: '\n',
          break: true,
        })

        if (
          editor.selection &&
          Editor.isEnd(editor, editor.selection.anchor, Path.parent(editor.selection.anchor.path)) &&
          Editor.parent(editor, editor.selection)?.[0]?.type !== 'a'
        ) return

        if (nextNode?.break) return
        Transforms.move(editor, { distance: 1, unit: 'offset' })
      }
      catch (e) {
        console.error(e)
      }
    })
  }

  if (isHotkey('shift+tab', event)) {
    event.preventDefault()

    const { selection, rteVersion } = editor

    if (selection) {
      const [li] = Editor.nodes(editor, {
        match: (n) => n.type === 'li',
        mode: 'lowest'
      })

      if (li) {
        if (rteVersion >= 1) {
          outdentMultipleListItemsForUpdatedListStructure(editor)
        }
        else { outdentMultipleListItems(editor) }
        return
      }

    }
  }
}

Registry.register(handleSoftBreak, {
  id: 'softbreak',
  registry: 'v2.keydown',
})
